import React from 'react'
import { Button } from 'antd'
import { Wrapper, Title, Text, Icon } from './NoBoardFounds.style'
import emptyProjectPlaceHolder from '../../../assets/images/icon/12.svg'
export default function NoBoardFounds({ history, match }) {
    return (
        <Wrapper>
            <Icon src={emptyProjectPlaceHolder} />
            <Title>Hiện tại chưa có nhiệm vụ nào.</Title>
            {/* <Text>Hãy tạo nhiệm vụ mới ngay tại đây</Text>
            <Button
                type="primary"
                onClick={() => history.push(`${match.url}/new`)}
            >
                Tạo mới nhiệm vụ
            </Button> */}
        </Wrapper>
    )
}
